
export function calcFooterSpaceForStickyOrderBox(productPage = document){
    const productPageOrderBoxSticky = productPage.querySelector(".productPageOrderBoxSticky");
    const pageFooter = document.querySelector("#container > footer");

    if(pageFooter && productPageOrderBoxSticky && window.innerWidth < 768){
        const productPageOrderBoxStickyHeight = productPageOrderBoxSticky.getBoundingClientRect().height;
        pageFooter.style.paddingBottom = productPageOrderBoxStickyHeight + "px";
    }
}